import React, { useCallback, useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { faAngleRight, faHandshakeSimpleSlash, faStar, faUsers } from '@fortawesome/free-solid-svg-icons';
import "./knowledge.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useParams } from 'react-router-dom';
import { faCalendar, faEye, faHandshake, faUser } from '@fortawesome/free-regular-svg-icons';
import { Rating } from '@mui/material';
import { apiService } from '../../services/apiService';
import { toast } from 'react-toastify';
import KnowledgeCategory from '../../components/common/KnowledgeCategory';
import { ResizableBox } from 'react-resizable';
import { eventBus } from '../../components/eventBus';
import ExportPdfModal from '../../components/exportkba/ExportPdfModal';
import { exportToPDF } from '../../components/exportkba/usePdfExport';
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
// import { Helmet } from 'react-helmet-async';
// import ScreenCaptureProtection from '../../components/ScreenCaptureProtection/ScreenCaptureProtection';

function KnowledgeArticleView() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [retireShow, setRetireShow] = useState(false);
    const [isRestrict, setIsRestrict] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [previewData, setPreviewData] = useState([]);
    const { slug } = useParams();
    const [idforslugs, setIdforslugs] = useState([]);
    const [isHelpful, setIsHelpful] = useState(null);
    const [ratingValue, setRatingValue] = useState(0);
    const [comment, setComment] = useState('');
    const [replyComments, setReplyComments] = useState({});
    const [activeCommentId, setActiveCommentId] = useState(null); // Track the comment ID with an open reply form
    const [errors, setErrors] = useState({});
    const [docudatas, setDocumentdatas] = useState([]);
    const [subcatsdatas, setSubcatsdatas] = useState([]);


    const printRef    = useRef(null);
    const [modalOpen,  setModalOpen]  = useState(false);
    const [exportMode, setExportMode] = useState("pdf");   // "pdf" | "pdf-attach"
    const [exporting,  setExporting]  = useState(false);
    const [exportProg, setExportProg] = useState(0);
    
    
    // ─── STEP 3 ── Add this handler inside your component function ────────────────
    
    const handleExportConfirm = async (selectedDocIds) => {
        if (selectedDocIds === null || selectedDocIds === undefined) return;

        setExporting(true);
        const articleData = previewData?.[0];
        try {
            const result = await exportToPDF({
                article:         articleData,
                articleContent:  articleData?.content ?? "",
                withAttachments: exportMode === "pdf-attach",
                documents:       docudatas?.documents ?? [],
                selectedDocIds,
                onProgress:      setExportProg,
                fileName:        `KBA-${articleData?.format_id ?? "Article"}`,
            });

            if (result === false) return; // ✅ cancelled — skip modal close & toast

            const VEXT = ["mp4","mpeg","webm","ogg","mov","avi","mkv","flv","wmv","m4v","3gp","wav","aac","mp3","flac","x-m4a"];
            const count = (docudatas?.documents ?? []).filter(d =>
                !VEXT.includes((d.extension||"").toLowerCase()) && selectedDocIds.includes(String(d.id))
            ).length;

            setModalOpen(false); // ✅ only closes on success
            toast(exportMode === "pdf-attach"
                ? `✓ PDF + ${count} attachment(s) downloaded`
                : "✓ PDF downloaded"
            );
        } catch (err) {
            console.error("Export failed:", err);
            toast.error("Export failed. Please try again.");
        } finally {
            setExporting(false);
            setExportProg(0);
        }
    };



    useEffect(() => {
        const handleToggle = (value) => {
            setIsVisible(value);
        };
        eventBus.on('toggleCategory', handleToggle);
        return () => {
            eventBus.off('toggleCategory', handleToggle);
        };
    }, []);
    const fetchPreviewData = useCallback(async () => {
        try {
            const response = await apiService.getRequest(`knowledge-articles/${slug}`);
            if (response && response.success === true) {
                setPreviewData(Array.isArray(response.data) ? response.data : [response.data]);
                setIdforslugs(response.data.id);
                setSubcatsdatas(response.data.subcategory);
                setRatingValue(response.data.user_rating);
                setIsHelpful(response.data.is_helpful);
                setDocumentdatas(response.data);
                setRetireShow(false);
            }else if(response && response.is_retired === true){
                setRetireShow(true);
            }else if(response && response?.error === "permission_denied"){
                setIsRestrict(true);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
                toast.error(response.message || "Failed to load a Article");
                setRetireShow(false);
                navigate("/knowledge");
            }
        } catch (error) {
            console.error('Error fetching group data:', error);
        } finally {
            setLoading(false);
        }
    }, [slug,navigate]); // Dependency on slug

    // Call fetchPreviewData on mount and whenever slug changes
    useEffect(() => {
        fetchPreviewData();
    }, [fetchPreviewData]);

    const handleReplyChange = (e, commentId) => {
        const { value } = e.target; // Get the current input value

        // Update the state to reflect the current textarea input
        setReplyComments((prevReplies) => ({
            ...prevReplies,
            [commentId]: value, // Set the value for the specific comment
        }));
    };

    const handleReplyClick = useCallback((commentId) => {
        setActiveCommentId(activeCommentId === commentId ? null : commentId);
    }, [activeCommentId]);

    const handleSubmitreply = useCallback(async (e, parentId) => {
        e.preventDefault(); // Prevent default form submission

        const replyText = replyComments[parentId]; // Get the current reply text
        if (!replyText) {
            return; // Prevent submission if empty
        }

        try {
            const jsonParams = {
                comment: replyText,
                parent_id: parentId,
            };
            const response = await apiService.postRequest(`knowledge-articles/${idforslugs}/comments`, jsonParams);
            if (response && response.success === true) {
                toast(response.message || "Comment Submitted");
                setReplyComments((prev) => ({
                    ...prev,
                    [parentId]: ''
                }));
                setActiveCommentId(null);
                fetchPreviewData();
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error submitting reply:', error);
        }
    }, [replyComments, idforslugs, fetchPreviewData]);


    const handleSubmit = async (e) => {
        e.preventDefault(); 
        const newErrors = {};
        if (comment.trim() === '') {
        newErrors.comment = "Please enter a comment.";
        }

        // If there are errors, update the errors state and do not submit
        if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
        }

        try{
            const jsonParams = {
                "comment": comment,
            }
            const response = await apiService.postRequest(`knowledge-articles/${idforslugs}/comments`,jsonParams);
            if(response && response.success === true){
                toast(response.message || "Comment Submitted");
                setComment("");
                fetchPreviewData();
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
            }catch (error) {
                console.error('Error fetching data:', error);
        }
    };


    const handleRatingChange = async (event, newValue) => {
        setRatingValue(newValue);
        try {
            const jsonParams = {
                rating: newValue,
            };
            const response = await apiService.postRequest(`knowledge-articles/${idforslugs}/ratings`, jsonParams);

            if (response && response.success === true) {
                toast("Rating Updated");
                fetchPreviewData();
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error updating rating:', error);
        }
    };

    const handleClick = async (value) => { 
        setIsHelpful(value);
        try {
            const jsonParams = {
                "is_helpful": value,
            };
            const response = await apiService.postRequest(`knowledge-articles/${idforslugs}/ratings`, jsonParams);

            if (response && response.success === true) {
                toast("Helpfull updated");
                fetchPreviewData();
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error updating rating:', error);
        }
    };

    // Trigger the Click function whenever isHelpful changes
    useEffect(() => {
        if (isHelpful !== null) {
            
        }
    }, [isHelpful]);
    
    const sanitizeAndDisplayHTML = (html) => {
        const sanitizedHTML = html
        return sanitizedHTML;
    };

    const handleSave = async (saveid) => {
        try {
            const params = ({
                article_id : saveid
            })
            const response = await apiService.postRequest('/bookmark/add',params);
            if(response && response.success === true){
                fetchPreviewData();
                toast(response.message || 'Bookmarked successfully!');
            }else{
                toast(response.message || 'Failed, try again!');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            toast.error("Failed to save job");
        }
    };
    const handleRemoveSave = async (saveid) => {
        try {
            const params = ({
                article_id : saveid
            })
            const response = await apiService.postRequest('/bookmark/remove',params);
            if(response && response.success === true){
                fetchPreviewData();
                toast(response.message || 'Remove Bookmark successfully!');
            }else{
                toast(response.message || 'Failed, try again!');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            toast.error("Failed to Unsave job");
        }
    };
  return (
    <>
    {retireShow && retireShow === true ?
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker" justifyContent="center" alignItems="center" style={{minHeight:"82vh"}}>
                <Grid size={{md:6,sm:8,xs:10}} container className="retirewarning" flexDirection="column" alignItems="center" justifyContent="center">
                    <img src={require("../../assets/retire_warning.svg").default} alt=''/>
                    <h4>KBA is retired, and is no longer viewable</h4>
                    <span>It has been removed as part of regular content updates to ensure accuracy and relevance.</span>
                    <button className='registersendbtn2 my-2 px-4' onClick={()=>navigate("/knowledge")} style={{width:"max-content"}}>Back to KB Article</button>
                </Grid>
            </Grid>
        </div>
    </div>
    : isRestrict && isRestrict === true ?
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker" justifyContent="center" alignItems="center" style={{minHeight:"82vh"}}>
                <Grid size={{md:6,sm:8,xs:10}} container className="retirewarning" flexDirection="column" alignItems="center" justifyContent="center">
                    <img src={require("../../assets/secure_warning.svg").default} alt=''/>
                    <span>You are restricted from viewing the article due to security reasons. If you have any questions regarding the article, please contact your recruiter.</span>
                    <button className='registersendbtn2 my-2 px-4' onClick={()=>navigate("/dashboard")} style={{width:"max-content"}}>Dashboard</button>
                </Grid>
            </Grid>
        </div>
    </div>
    :
    <div className='container-fluid px-0' style={{overflowX:"hidden"}}>
        <div className="resizable-container d-flex">
            <div className="d-lg-block d-none">
                <ResizableBox
                    className="knowledge-category"
                    width={400}
                    height={Infinity}
                    minConstraints={[400, Infinity]}
                    maxConstraints={[window.innerWidth - 800, Infinity]}
                    axis="x"
                    resizeHandles={['e']}
                >
                    <div className="knowledge-category-content">
                        <KnowledgeCategory 
                        selectedKbaseId={subcatsdatas && subcatsdatas.base_id}
                        selectedCategory={subcatsdatas && subcatsdatas.category_id}
                        selectedSubCategory={subcatsdatas && subcatsdatas.subcategory_id}/>
                    </div>
                </ResizableBox>
                </div>
                <div className="d-lg-none d-block">
                    <div className={isVisible !== true ? 'hide_mobitr' : 'show_mobitr'}>
                        <KnowledgeCategory
                        selectedKbaseId={subcatsdatas && subcatsdatas.base_id}
                        selectedCategory={subcatsdatas && subcatsdatas.category_id}
                        selectedSubCategory={subcatsdatas && subcatsdatas.subcategory_id}/>
                    </div>
                </div>
            <div className='content_container_articals_drag2' style={{ flexGrow: 1 }}>
                {loading ? 
                <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
                    <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                </div> :<>
                {previewData && previewData.map((article) => (
                <div key={article.id} className='w-100 overflow-auto'>
                <Grid size={{sm:12}} container className="main_jobseeker" style={{background:"#fff"}}>
                    <Grid size={{sm:12}} container alignItems="center">
                        <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                            <h3>Knowledge Article</h3>
                            <span className='d-lg-flex d-none'><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                            <b onClick={()=>navigate("/knowledge")}>Knowledge Article</b><FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                            <b onClick={()=>{navigate('/knowledge'); localStorage.setItem('knowledgeKbaseBackId', String(article.base.id))}}>{article.base.name}</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                            <b onClick={()=>{navigate('/knowledge'); localStorage.setItem('knowledgeCatBackId', String(article.subcategory.category_id));localStorage.setItem('knowledgeKbaseBackId', String(article.base.id))}}>{article.subcategory.category_name}</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                            <b onClick={()=>{navigate('/knowledge'); localStorage.setItem('knowledgeBackId', String(article.subcategory.id));}}>{article.subcategory.name}</b></span>
                            <span className='d-lg-none d-block wrap_ellipseset'>
                            <b onClick={()=>navigate("/knowledge")}>All Articles</b><FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                            <b onClick={()=>{navigate('/knowledge'); localStorage.setItem('knowledgeKbaseBackId', String(article.base.id))}}>{article.base.name}</b><FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                            <b onClick={()=>{navigate('/knowledge'); localStorage.setItem('knowledgeCatBackId', String(article.subcategory.category_id));localStorage.setItem('knowledgeKbaseBackId', String(article.base.id))}}>{article.subcategory.category_name}</b><FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                            <b onClick={()=>{navigate('/knowledge'); localStorage.setItem('knowledgeBackId', String(article.subcategory.id));}}>{article.subcategory.name}</b></span>
                        </Grid>
                    </Grid>
                    <ExportPdfModal
                        open={modalOpen}
                        mode={exportMode}
                        documents={docudatas?.documents ?? []}
                        loading={exporting}
                        progress={exportProg}
                        onClose={() => !exporting && setModalOpen(false)}
                        onConfirm={handleExportConfirm}
                    />
                    <Grid size={{sm:12}} container justifyContent="center" className="mt-lg-4 mt-3">
                        <Grid ref={printRef} size={{sm:12}} container justifyContent="center" className="knowledge_lister">
                            <Grid size={{xs:12}} container justifyContent="space-between" alignItems="flex-start">
                                <span className="formatid_copyclip"
                                    onClick={async () => {
                                        const url = `${window.location.origin}/knowledge-article/${article.format_id}`;
                                        const title = article.title || "Knowledge Article";

                                        // Plain text: first line = ID + title, second line = raw URL
                                        const textPlain = `${article.format_id}: ${title}\n${url}`;

                                        // Rich text: clickable anchor
                                        const textHtml = `<a href="${url}" target="_blank">${article.format_id}: ${title}</a>`;

                                        try {
                                        await navigator.clipboard.write([
                                            new ClipboardItem({
                                            "text/html": new Blob([textHtml], { type: "text/html" }),
                                            "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                            }),
                                        ]);
                                        toast("Link copied to clipboard");
                                        } catch (err) {
                                        console.error("Failed to copy: ", err);
                                        toast("Failed to copy link");
                                        }
                                    }}
                                    >
                                    {article.format_id}
                                </span>
                                <div className='d-flex gap-3 flex-wrap'>
                                    {article?.is_preview_render === 1 &&
                                    <button
                                        onClick={() => { setExportMode("pdf-attach"); setModalOpen(true); }}
                                        style={{
                                            display:"inline-flex", alignItems:"center", gap:7,
                                            padding:"8px 12px", borderRadius:8, border:"none",
                                            background:"#C32A7C",
                                            color:"#fff", fontSize:13, fontWeight:600, cursor:"pointer",
                                            transition:"transform .12s, box-shadow .12s",
                                        }}
                                        onMouseEnter={e => { e.currentTarget.style.transform="translateY(-1px)"; }}
                                        onMouseLeave={e => { e.currentTarget.style.transform="translateY(0)"; }}
                                    >
                                        <FontAwesomeIcon icon={faFilePdf} />
                                    </button>}
                                    {article && article.is_bookmarked === true ?
                                        <button className='save_bookmark d-lg-block d-none' onClick={() => handleRemoveSave(article.id)}><img src={require("../../assets/bookmark_bluesave.svg").default} alt="save"/></button> :
                                        <button className='save_bookmark d-lg-block d-none' onClick={() => handleSave(article.id)}><img src={require("../../assets/bookmark_blueunsave.svg").default} alt="save"/></button>
                                    }
                                </div>
                            </Grid>
                            <h4>{article.title}</h4>
                            <Grid size={{xs:12}} container className="span_griders d-lg-block d-none mb-4">
                                <span><FontAwesomeIcon icon={faUser} className='icon_kn'/><small>Authored by :</small>{article.author.name}</span>
                                <span><FontAwesomeIcon icon={faUsers} className='icon_kn'/><small>Group :</small>{article.owned_by_group}</span>
                                <span><FontAwesomeIcon icon={faEye} className='icon_kn'/>{article.view_count} Views</span>
                                <span><FontAwesomeIcon icon={faHandshake} className='icon_kn'/>{article.helpful_true_count} Helpful</span>
                                <span><FontAwesomeIcon icon={faHandshakeSimpleSlash} className='icon_kn'/>{article.helpful_false_count} UnHelpful</span>
                                <span><FontAwesomeIcon icon={faCalendar} className='icon_kn'/>{article.created_at}</span>
                                <Rating className='rating_spanhiders' disabled value={JSON.parse(article.overall_rating)} />
                            </Grid>
                            <Grid size={{xs:12}} container className="gap-3 mb-lg-3 d-lg-flex d-none">
                                {Array.isArray(docudatas.documents) ? (
                                    docudatas.documents.map(docum => (
                                    <Grid key={docum.id} size={{lg:2.8,md:2.8,sm:3.8,xs:12}} alignItems="center" container className="documentcards">
                                        {docum && (docum.extension ==="docx" || docum.extension ==="word") ?
                                        <img src={require('../../assets/svg2.svg').default} alt={docum.name} /> : docum && docum.extension ==="pdf" ? <img src={require('../../assets/svg1.svg').default} alt={docum.name} /> : docum && (docum.extension ==="csv" || docum.extension ==="xls" || docum.extension ==="xlsx") ? <img src={require('../../assets/svg4.svg').default} alt={docum.name} /> :
                                         docum && (docum.extension ==="mpeg" || docum.extension ==="wav" || docum.extension ==="ogg" || docum.extension ==="webm" || docum.extension ==="aac" || docum.extension ==="mp4" || docum.extension ==="x-m4a" || docum.extension ==="mp3" || docum.extension ==="flac") 
                                         ? <img src={require('../../assets/svg5.svg').default} alt={docum.name} /> : docum && (docum.extension ==="ppt" || docum.extension ==="pptx") ? <img src={require('../../assets/svg6.svg').default} alt={docum.name} /> :<img src={require('../../assets/svg3.svg').default} alt={docum.name}/>
                                        }
                                        <a href={docum.file_path} target="_blank" rel="noopener noreferrer">{docum.document_name}</a>
                                    </Grid>
                                    ))
                                ) : (
                                    ""
                                )}
                            </Grid>
                            <div className='w-100 caliberifontsset mob_videoset' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(article.content) }} />
                        </Grid>
                    </Grid>
                    <Grid size={{xs:12}} container className="d-lg-none">
                        <Grid size={{xs:12}} container className="span_griders my-3">
                            <span><FontAwesomeIcon icon={faUser} className='icon_kn'/>{article.author.name}</span>
                            <span><FontAwesomeIcon icon={faEye} className='icon_kn'/>{article.view_count}</span>
                            <span><FontAwesomeIcon icon={faCalendar} className='icon_kn'/>{article.created_at}</span>
                            <span><FontAwesomeIcon icon={faStar} className='icon_kn_yellow'/>{JSON.parse(article.overall_rating)}</span>
                        </Grid>
                        {docudatas.documents && docudatas.documents.length > 0 && 
                        <Grid size={{xs:12}} container className="gap-3 mb-lg-3 main_mobiledocumentkb">
                            {Array.isArray(docudatas.documents) ? (
                                docudatas.documents.map(docum => (
                                <Grid key={docum.id} size={{lg:2.8,md:2.8,sm:3.8,xs:12}} alignItems="center" container className="documentcards">
                                    {docum && (docum.extension ==="docx" || docum.extension ==="word") ?
                                    <img src={require('../../assets/svg2.svg').default} alt={docum.name} /> : docum && docum.extension ==="pdf" ? <img src={require('../../assets/svg1.svg').default} alt={docum.name} /> : docum && (docum.extension ==="csv" || docum.extension ==="xls" || docum.extension ==="xlsx") ? <img src={require('../../assets/svg4.svg').default} alt={docum.name} /> : 
                                    docum && (docum.extension ==="mpeg" || docum.extension ==="wav" || docum.extension ==="ogg" || docum.extension ==="webm" || docum.extension ==="aac" || docum.extension ==="mp4" || docum.extension ==="x-m4a" || docum.extension ==="mp3" || docum.extension ==="flac") ?
                                    <img src={require('../../assets/svg5.svg').default} alt={docum.name}/>:
                                    docum && (docum.extension ==="ppt" || docum.extension ==="pptx") ? <img src={require('../../assets/svg6.svg').default} alt={docum.name} /> :
                                    <img src={require('../../assets/svg3.svg').default} alt={docum.name}/>
                                    }
                                    <a href={docum.file_path} target="_blank" rel="noopener noreferrer">{docum.document_name}</a>
                                </Grid>
                                ))
                            ) : (
                                ""
                            )}
                        </Grid>}
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="center" className="mt-lg-4 top_downborders">
                        <Grid container size={{sm:6,xs:12}} alignItems="center" className="my-md-0 my-2">
                        <span className='raters_helpspan'>Helpful?</span>
                        <button 
                            type="button" 
                            className={isHelpful === true ? "yes_nohelper_selector" : 'yes_nohelper'}
                            onClick={() => handleClick(true)}
                        >
                            Yes
                        </button>
                        <button 
                            type="button" 
                            className={isHelpful === false ? "yes_nohelper_selector" : 'yes_nohelper'}
                            onClick={() => handleClick(false)}
                        >
                            No
                        </button>
                        </Grid>
                        <Grid container size={{sm:6,xs:12}} alignItems="center" alignContent="center" className="my-md-0 my-2 justify-content-md-end">
                        <span className='raters_helpspan'>Rate this article</span>
                        <Rating 
                            className='rating_spanhiders' 
                            value={ratingValue} 
                            onChange={handleRatingChange}
                        />
                        </Grid>
                    </Grid>
                    <form className='w-100 d-lg-block d-none' onSubmit={handleSubmit}>
                        <Grid size={{sm:12}} container justifyContent="flex-end" className="mt-4">
                            <textarea 
                            className='comment_textarea' 
                            placeholder="Post a comment...." 
                            value={comment} 
                            onChange={(e) => setComment(e.target.value)} 
                            />
                            <div className='w-100'>
                                {errors.comment && <p style={{color:"red"}}>{errors.comment}</p>}
                            </div>
                            <button type="submit" className='submit_btn'>Submit</button>
                        </Grid>
                    </form>
                    <Grid size={{sm:12}} container justifyContent="center" className="mt-4 previous_comments d-lg-block d-none">
                        {article && article.comments.map((comment) => (
                            <Grid size={{ sm: 12 }} key={comment.id} container alignItems="center" justifyContent="space-between" className="mb-4 reply_comment_btn">
                            <small className='pink_small'>{comment.user}</small>
                            <small className='datetime_small'>{comment.created_at}</small>
                            <span>{comment.comment}</span>
                            <button className='reply_btntext' onClick={() => handleReplyClick(comment.id)}>
                                {activeCommentId === comment.id ? "Cancel" : "Reply"}
                            </button>
                    
                            {activeCommentId === comment.id && (
                                <div className='d-flex flex-column w-100 mb-2'>
                                    <textarea
                                        value={replyComments[comment.id] || ''} // Ensure correct value binding
                                        onChange={(e) => handleReplyChange(e, comment.id)} // Update on change
                                        placeholder="Write your reply..."
                                    />
                                    <button style={{opacity:!replyComments[comment.id]?.trim() ? "0.8":"1"}} disabled={!replyComments[comment.id]?.trim()}  onClick={(e) => handleSubmitreply(e, comment.id)}>Send Reply</button>
                                </div>
                            )}
                            {comment.replies && comment.replies.map((reply) => (
                                <Grid size={{ sm: 12 }} key={reply.id} container alignItems="center" justifyContent="space-between" className="mb-4 ps-5 reply_comment_btn">
                                    <small className='pink_small'>{reply.user} <small>(@{reply.parentUser})</small></small>
                                    <small className='datetime_small'>{reply.created_at}</small>
                                    <span>{reply.comment}</span>
                                    <button className='reply_btntext' onClick={() => handleReplyClick(reply.id)}>
                                        {activeCommentId === reply.id ? "Cancel" : "Reply"}
                                    </button>
                            
                                    {activeCommentId === reply.id && (
                                        <div className='d-flex flex-column w-100'>
                                            <textarea
                                                value={replyComments[reply.id] || ''} // Ensure correct value binding
                                                onChange={(e) => handleReplyChange(e, reply.id)} // Update on change
                                                placeholder="Write your reply..."
                                            />
                                            <button style={{opacity:!replyComments[reply.id]?.trim() ? "0.8":"1"}} disabled={!replyComments[reply.id]?.trim()} onClick={(e) => handleSubmitreply(e, reply.id)}>Send Reply</button>
                                        </div>
                                    )}
                                </Grid>
                            ))}
                        </Grid>
                        ))}
                    </Grid>
                </Grid>
            </div>
        
        ))
        }
    </>}
            </div>
        </div>
    </div>
    }
    </>
  )
}

export default KnowledgeArticleView
